import { Component, OnInit, Inject, ViewChild, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { LoaderService } from 'src/app/core/helpers/loader.service';
import { GaService } from 'src/app/core/helpers/ga.service';
import { LocalizationService } from 'src/app/core/helpers/localization.service';
import { DataServiceService } from 'src/app/core/helpers/data-service.service';


@Component({
  selector: 'loyaltic-play',
  templateUrl: './play.component.html',
  styleUrls: ['./play.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class PlayComponent implements OnInit, AfterViewInit {
  @ViewChild('noGamesAvailable', { static: false }) noGamesAvailableRef: any;

  culture = '';
  showWinComponent = false;
  showNoWinComponent = false;


  cloudinarySource = 'https://res.cloudinary.com/lojaali/video/upload/q_auto/v1600774211/finpres20/';
  status = '';
  userId: any;
  playType = '';
  public modalRef!: BsModalRef;
  popupConfig = {
    ignoreBackdropClick: true,
    class: 'lyltc win modal-md modal-dialog-centered',
  };

  showMainVideo = true;
  showModal: boolean = false;
  content: string = '';
  showPlayBtn: boolean = false;

  playResult: any;

  playAnimation = '';
  playMobileAnimation = '';
  hasPlayed = false;
  animationLoaded = false;

  message: string = '';
  popupKeysObj : any;
  headerKey = '';
  bodyKey = '';
  showGenericPopup = false;

  constructor(
    public translate: TranslateService,
    private modalService: BsModalService,
    private authService: AuthService,
    private router: Router,
    private coreService: CoreService,
    private loader: LoaderService,
    private dataService: DataServiceService,
    private gaService: GaService,
    @Inject('ImagePath') public ImagePath:any
  ) {
    this.culture = translate.getDefaultLang();

    // this.dataService.getPlay.subscribe((response: any) => {
    //   // this.IsLoggedIn = response;
    //   console.log("response",response)
    // });

  }

  winDetails = {
    availableGames: 0,
    email: '',
    gameRK: '',
    hasWon: false,
    isFreeReward: false,
    isRewardDeliverable: true,
    reward: '',
    rewardPK: '',
    rewardSmallImage: '',
    rewardDescription: '',
    rewardImage: '',
    userRewardRK: '',
    videoName: '',
    mobileVideoName: ''
  };

  captureAddress = {
    Name: '',
    Email: '',
    Phone: '',
    Address: '',
    PostalCode: '',
    City: ''
  };
  onSubmitWinWithReceipt(f:any) { }
  numberOnly(event:any) { }
  hide() {
    this.showModal = false;
  }


  onPlayClick() {
    this.getPlay();
  }

  ngAfterViewInit(): void {
  }


  ngOnInit() {
    // if(localStorage.getItem('playAgain') === 'true'){
    //   this.getPlay()
    // } else {
    this.userId = this.authService.getUserId();
     if (!this.userId) {
       this.router.navigate(['/']);
       return;
     } else {
       this.showPlayBtn = true;
       this.playType = localStorage.getItem('playType');

       this.getPlay()

     }
  }

  getPlay() {
    const playType = localStorage.getItem('playType');
    this.coreService.instantWinPlay(this.userId, 0).then((response: any) => {

      if (this.modalRef) {
        this.modalRef.hide();
      }

      let playStatus = '';
      this.playResult = response.result;
      // to check win popup remove following 2 lines
      // this.playResult.isRewardDeliverable = false;
      // this.playResult.hasWon = true;

      this.dataService.winDetails = this.playResult;
      this.winDetails = this.playResult;


      if(this.playResult.isFreeGame) {
        this.gaService.emitEvent('play_without_logo', 'play_without_logo');
      } else if(!this.playResult.isFreeGame) {
        this.gaService.emitEvent('play_with_logo', 'play_with_logo');
      }

      // this.gaService.emitEvent('play', playStatus);
      // this.gaService.conversionEmitter("SpinTheWheel");
      if (this.playResult.hasWon) {
        // this.gaService.emitEvent('win', '1');
        this.gaService.emitEvent(this.winDetails.isRewardDeliverable ? 'Deliverable' : 'Not deliverable', 'Play Screen');
      }
      this.playAnimation = this.playResult.videoName;
      this.playMobileAnimation = this.playResult.mobileVideoName;
      this.hasPlayed = true;
      this.showPlayBtn = false;
    });
  }

  playAgain() {
    this.getPlay();
  }

  redirectToUpload() {
    this.modalRef.hide();
    //this.router.navigate(['home', 'PlayWithReceipt']);
    this.router.navigate(['', 'PlayWithReceipt'])
  }

  redirectToHome() {
    this.modalRef.hide();
    this.router.navigate(['/']);
  }

  pickRandom() {
    return Math.floor(Math.random() * 2) + 1;
  }

  onWinAnimationEnd() {
    this.hasPlayed = false;
    this.animationLoaded = false;
    this.showPlayBtn = true;
    console.log("===========wim", this.playResult)
    if (this.playResult.hasWon) {
      this.showWinComponent = true;
      // this.router.navigate(['win'])
      // this.modalRef = this.modalService.show(this.winPopupWithReceiptRef, this.popupConfig);
    } else if (!this.playResult.hasWon) {
      this.showNoWinComponent = true;
      // this.router.navigate(['no-win'])
      // this.modalRef = this.modalService.show(this.noWinPopupWithReceiptRef, this.popupConfig);
    }
  }
}
